import { useTranslation } from 'react-i18next'

import { returnStatuses } from '@reveni-io/reveni-ui'

import ContactMessage from '../ContactMessage/ContactMessage'
import { isExchangeOrMixedWithoutPayment, isExchangeOrMixedWithPayment } from '../helpers'

const Instructions = ({
  customerEmail,
  orderTransactionType,
  exchangedForOrder,
  orderStatus,
  storeReplyToEmail,
  contactMethod,
  contactUrl,
}) => {
  const { t } = useTranslation()

  if (orderStatus === returnStatuses.cancelled) {
    return (
      <>
        <p>
          {t(
            'Por esta razón hemos cancelado tu solicitud, para que puedas volver a iniciar el cambio por otros productos que estén disponibles en la tienda.'
          )}
        </p>
        <ContactMessage
          contactMethod={contactMethod}
          contactEmail={storeReplyToEmail}
          contactUrl={contactUrl}
          orderStatus={orderStatus}
        />
      </>
    )
  }

  if (orderStatus === returnStatuses.onHold) {
    return (
      <>
        <p>
          {t('Una vez se apruebe tu solicitud, recibirás instrucciones para devolver tus productos en ')}
          <strong>{customerEmail}</strong>
        </p>
        <ContactMessage
          contactMethod={contactMethod}
          contactEmail={storeReplyToEmail}
          contactUrl={contactUrl}
          orderStatus={orderStatus}
        />
      </>
    )
  }

  return (
    <>
      {isExchangeOrMixedWithPayment(orderTransactionType, exchangedForOrder) ||
      isExchangeOrMixedWithoutPayment(orderTransactionType, exchangedForOrder) ? (
        <>
          <p>
            {t('Una vez completado el pago recibirás instrucciones para devolver tus productos en ')}
            <strong>{customerEmail}</strong>
          </p>
        </>
      ) : (
        <>
          <p>
            {t('Ahora devuelve tus productos siguiendo paso a paso las instrucciones que te hemos mandado a ')}
            <strong>{customerEmail}</strong>
          </p>
        </>
      )}
      <ContactMessage
        contactMethod={contactMethod}
        contactEmail={storeReplyToEmail}
        contactUrl={contactUrl}
        orderStatus={orderStatus}
      />
    </>
  )
}

export default Instructions
